<template>
  <crud-update :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @update="update"
               @close="$emit('close')"
  >
    <product-form ref="form" v-model="form" :input-errors="inputErrors"/>
  </crud-update>
</template>

<script>

import ProductProvider from "../../../../providers/ProductProvider";

import {CrudUpdate, ClientError} from '@dracul/common-frontend'

import ProductForm from "../ProductForm";

import SalesChannelsConfig from '../ProductForm/SalesChannelsConfig'

export default {
  name: "ProductUpdate",

  components: {ProductForm, CrudUpdate},

  props: {
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },

  data() {
    return {
      title: 'delivery.product.editing',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      id: this.item.id,
      form: {
        salesChannelsConfig: new SalesChannelsConfig(this.item.salesChannelsConfig?.web, this.item.salesChannelsConfig?.mostrador, this.item.salesChannelsConfig?.salon),
        name: this.item.name,
        shortName: this.item.shortName,
        description: this.item.description,
        image: this.item.image,
        price: this.item.price,
        active: this.item.active,
        ingredients: this.item.ingredients ? this.item.ingredients.map(i => i.id ? i.id : i) : null,
        categories: this.item.categories ? this.item.categories.map(i => i.id ? i.id : i) : null,
        imageCategory:  this.item.imageCategory ? this.item.imageCategory : [],
        featured: this.item.featured,
        homeGallery: this.item.homeGallery
      }
    }
  },
  methods: {
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true
        ProductProvider.updateProduct(this.id, this.form).then(r => {
              if (r) {
                this.$emit('itemUpdated', r.data.updateProduct)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }
  },
}
</script>

<style scoped>

</style>

